import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { LocalStorageService } from '../utility/localStorageService';

@Component({
  selector: 'app-idle-dialog',
  templateUrl: './idle-dialog.component.html'
})
export class IdleWarningModalComponent {

  seconds: number = 0;   // countdown value
  onContinue!: () => void;
  onLogout!: () => void;

  constructor(public bsModalRef: BsModalRef,private router :Router,private localStorage:LocalStorageService) {}

  continue() {
    if (this.onContinue) this.onContinue();
    this.bsModalRef.hide();
  }

  logout() {
    if (this.onLogout) this.onLogout();
    this.localStorage.set("token",null)
    this.router.navigateByUrl("login")
    this.bsModalRef.hide();
  }
}
